import { useEffect } from 'react'
import type { Maybe } from '@awell/ui-kit/utils'
import { useGetPatientQuery, type Patient } from './types'
import { useNotifications } from '../useNotifications'

interface UsePatientHook {
  loading: boolean
  patient?: Maybe<Patient>
}

export const usePatient = (patient_id: string): UsePatientHook => {
  const { notifyError } = useNotifications()
  const { data, loading, error } = useGetPatientQuery({
    variables: {
      patient_id
    }
  })

  // Only notify error when error state actually changes, not on every render
  useEffect(() => {
    if (error) {
      notifyError({
        message: 'something went  wrong while loading a patient',
        error
      })
    }
  }, [error, notifyError])

  if (error) {
    return { loading: false }
  }
  if (loading) {
    return { loading: true }
  }

  return {
    loading: false,
    patient: data?.patient.patient
  }
}
